import { MOBILE_SCREEN_SIZE } from "@brandclub/common-ui";
import ChooseMFAOption from "@/components/pages/AppPages/Sync/MFA/ChooseMFAOption";
import { CloseButton } from "@brandclub/common-ui";
import Box from "@mui/material/Box";
import Dialog from "@mui/material/Dialog";
import { styled } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { MFADialogProps } from "../types";

const StyledChooseMFAOption = styled(ChooseMFAOption)(() => ({
  flex: 1,
  minHeight: "unset",
  "& .auth_container": {
    justifyContent: "center",
  },
}));

export const ChooseMFAOptionDialog = (props: MFADialogProps) => {
  const isMobileView = useMediaQuery(`(max-width:${MOBILE_SCREEN_SIZE}px)`);
  return (
    <Dialog {...props.dialogProps} fullScreen={isMobileView}>
      <Box
        sx={{
          marginBottom: "20px",
          width: "600px",
          maxWidth: "100%",
          maxHeight: "100%",
          display: "flex",
          flexDirection: "column",
          flex: 1,
          justifyContent: "center",
          [`@media (max-width: ${MOBILE_SCREEN_SIZE}px)`]: {
            marginBottom: 0,
          },
        }}
      >
        <Box
          component="button"
          sx={{
            background: "none",
            border: "none",
            outline: "none",
            alignSelf: "flex-end",
            padding: 0,
            marginTop: "28px",
            marginRight: "28px",
            [`@media (max-width: ${MOBILE_SCREEN_SIZE}px)`]: {
              marginTop: "48px",
              marginRight: "30px",
            },
          }}
        >
          <CloseButton iconSize={12.5} onClick={props.handleDialogClose} />
        </Box>
        <StyledChooseMFAOption
          retailerId={props.retailerId}
          retailerSyncSession={props.retailerSyncSession}
          onCompleteCallback={props.onCompleteCallback}
        />
      </Box>
    </Dialog>
  );
};
